import { FC, useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';

import clsx from 'clsx';
import InputMask from 'react-input-mask';

import { AppDispatch } from '../../../redux/reducer/store';
import { actionGetSingleApplication } from '../../../redux/action/recruiting/actionApplicationForm';
import { reducerSingleApplicationIV, reducerSingleApplicationStatus, reducerSingleApplicationErrors } from '../../../redux/reducer/recruiting/reducers/reducerSingleApplication';
import { formatDateWithDots } from '../../../utils/formatDate';
import { generateStyles } from '../../../utils/generateToastStyles';
import Select from '../../custom/select/select';
import Loader from '../../custom/loader/loader';
import ToastPopup from '../../custom/toastPopup/toastPopup';
import CustomMultiSelect from "../../custom/customMultiSelect/customMultiSelect";

import styles from './recruiting.module.scss';
import '../../table/table.scss';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableSingleApplication: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { id } = useParams<{ id: string }>();

	const [isPending, setIsPending] = useState<boolean>(true);

	const { isOpenSidebar } = useSelector((state: any) => state.user.user);

	const {
		advertisingSource,
		advertisingSources,
		advertisingCategory,
		advertisingCategories,
		applicantCondition,
		applicantStatus,
		desiredPosition,
		declineComment,
		internshipDate,
		modifiedDate,
		createdDate,
		middleName,
		firstName,
		createdBy,
		lastName,
		formData,
		comment,
		vacancy,
		gender,
		subway,
		phone,
	} = useSelector((state: any) => state.recruiting?.singleApplication?.data);
	const { applicationInputValues, clientsStatusMessage, clientsStatus, applicationErrors: errors } = useSelector((state: any) => state.recruiting?.singleApplication);
	const isDesiredPositionIncluded = (formData && formData.desiredPositions.includes(applicationInputValues.desiredPosition)) || !applicationInputValues.desiredPosition;
	const desiredPositionSelect = !isDesiredPositionIncluded ? 'Другая' : applicationInputValues.desiredPosition;

	const requestStatusOptions = [
		{
			status: 200,
			successMessage: "Анкета успешно сохранена",
		},
		{
			status: 400,
			errorMessage: "Заполните обязательные поля: Статус кандидата, Фамилия, Имя, пол.",
		},
		{
			status: 1,
			errorMessage: clientsStatusMessage,
		},
	];
	const selectChange = (event: any, name: string) => {
		if (name === 'advertisingSource' || name === 'advertisingCategory') {
			dispatch(
				reducerSingleApplicationIV({
					...applicationInputValues,
					[name]: { id: event.value, name: event.label }
				})
			);
		} else {
			dispatch(
				reducerSingleApplicationIV({
					...applicationInputValues,
					[name]: name === 'project' ? { id: event.value }
						: name === 'desiredPosition' || name === 'applicantCondition' ? event.value
							: event.value[0],
				})
			);
		}
	};

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		if (name === 'newDesiredPosition') {
			dispatch(
				reducerSingleApplicationIV({
					...applicationInputValues,
					'desiredPosition': value,
				})
			);
		} else {
			dispatch(
				reducerSingleApplicationIV({
					...applicationInputValues,
					[name]: value,
				})
			);
		}
	};
	const handleTextareaChange = (
		event: React.ChangeEvent<HTMLTextAreaElement>
	) => {
		const { name, value } = event.target;
		dispatch(
			reducerSingleApplicationIV({ ...applicationInputValues, [name]: value })
		);
	};
	useEffect(() => {
		if (applicantStatus) {
			dispatch(reducerSingleApplicationIV({
				...applicationInputValues,
				applicantStatus: Object.keys(applicantStatus)[0],
				firstName: firstName,
				lastName: lastName,
				gender: Object.keys(gender)[0],
				declineComment: declineComment,
				applicantCondition: applicantCondition,
				comment: comment,
				desiredPosition: desiredPosition,
				advertisingSource: advertisingSource,
				advertisingCategory: advertisingCategory,
				middleName: middleName,
				phone: phone ? phone : "",
				subway: subway ? subway : "",
			}))
		}
		// eslint-disable-next-line
	}, [applicantStatus, firstName, lastName, gender])

	useEffect(() => {
		if (id) {
			dispatch(actionGetSingleApplication(id)).then(() => {
				setIsPending(false);
			});
		}
	}, [dispatch, id]);

	useEffect(() => {
		requestStatusOptions.forEach((option: any) => {
			if (clientsStatus === option.status) {
				toast.dismiss();

				toast(
					t => (
						<ToastPopup
							title={
								option.successMessage
									? option.successMessage
									: option.errorMessage
							}
							isSuccess={option.successMessage ? true : false}
							toast={toast}
							t={t}
						/>
					),
					generateStyles(option.successMessage ? true : false)
				);
			}
		});

		dispatch(reducerSingleApplicationStatus(null));
		// eslint-disable-next-line
	}, [dispatch, clientsStatus]);

	useEffect(() => {
		if (applicationInputValues?.firstName !== undefined && errors?.includes('firstName')) {
			dispatch(reducerSingleApplicationErrors(errors.filter((error: any) => error !== 'firstName')))
		}
		if (applicationInputValues?.lastName !== undefined && errors?.includes('lastName')) {
			dispatch(reducerSingleApplicationErrors(errors.filter((error: any) => error !== 'lastName')))
		}
	}, [applicationInputValues, dispatch, errors])
	return (
		<>
			<div className='loader__wrapper'>{isPending && <Loader />}</div>
			<div
				className={clsx(
					JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
					isOpenSidebar &&
					'customerSingle__report_activeTable',
					!isOpenSidebar && 'customerSingle__report_closedTable',
					'vacancy_create_table'
				)}
			>
				<Toaster
					position='top-center'
					toastOptions={{
						duration: 5000,
					}}
				/>
				<div className={styles.tableWrapper}>
					<div className={styles.midSectionWrapper}>
						<h1 className={styles.title}>Анкета № {id}</h1>
					</div>

					<div className={styles.midSectionWrapper}>
						<div className={styles.halfBlock}>
							{vacancy && <div className={styles.vacancyBlock}>
								<span className='section__title'>Вакансия</span>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Название
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}></div>
										<div className={styles.subBlock__right__text}>
											<Link to={`/recruiting/vacancy/${vacancy?.id}`} className="file__link">{vacancy?.name}</Link>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Город</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}></div>
										</div>
									</div>
								</div>

								<div>
                <div className='reports__region_block-select'>
                    <CustomMultiSelect
                        setLoading={() => {}}
                        setState={() => {}}
                        action={() => {}}
                        reducer={() => {}}
                        inputValues={() => {}}
                        isShowPlaceholder={true}
                        placeholder='Проект'
                        name='projects'
                        pageName='type2'
                        options={[]}
                        resetPages={() => {
                        }}
                    />
                </div>
           			</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Список адресов
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}></div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Виртуальный супервайзер
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}></div>
										</div>
									</div>
								</div>

								<div>
								<div className='reports__region_block-select'>
                    <CustomMultiSelect
                        setLoading={() => {}}
                        setState={() => {}}
                        action={() => {}}
                        reducer={() => {}}
                        inputValues={() => {}}
                        isShowPlaceholder={true}
                        placeholder='Супервайзер'
                        name='sv'
                        pageName='type2'
                        options={[]}
                        resetPages={() => {
                        }}
                    />
                </div>
            	</div>

							</div>}

							<div className={styles.vacancyBlock}>
								<span className='section__title'>Описание</span>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Автор</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{createdBy?.name}
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Дата создания
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{createdDate && formatDateWithDots(createdDate)}
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Дата последнего изменения статуса
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{modifiedDate && formatDateWithDots(modifiedDate)}
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Статус кандидата
											<span className={styles.changed}>*</span>
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={clsx(styles.filterInput, errors.includes('status') && styles.error)}>
											<Select
												className={styles.filterSelect}
												defaultValue={
													applicantStatus && Object.values(applicantStatus)
												}
												options={formData?.status.map((el: any) => ({
													value: Object.keys(el),
													label: Object.values(el),
												}))}
												propsChange={(event: any) =>
													selectChange(event, 'applicantStatus')
												}
												placeholder={
													(applicantStatus && Object.values(applicantStatus)) || 'Выбрать'
												}
												name='status'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Состояние кандидата
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												className={styles.filterSelect}
												propsChange={(event: any) =>
													selectChange(event, 'applicantCondition')
												}
												options={formData?.applicantConditions.map((el: any) => ({
													value: el,
													label: el,
												}))}
												placeholder={
													(applicantCondition &&
														Object.values(applicantCondition)) || 'Выбрать'
												}
												name='status'
											/>
										</div>
									</div>
								</div>

								{applicantStatus && (Object.keys(applicantStatus).includes('AIM_INTERNSHIP') || applicationInputValues?.applicantStatus === 'AIM_INTERNSHIP') && <div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Дата направления на стажировку
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												<input
													defaultValue={internshipDate && formatDateWithDots(internshipDate)}
													onChange={handleInputChange}
													autoComplete='off'
													placeholder=' '
													name='internshipDate'
													type='text'
												/>
											</div>
										</div>
									</div>
								</div>}

								{applicantStatus &&
									applicationInputValues?.applicantStatus === 'REJECT_MANAGER' &&
									<div className={styles.subBlock}>
										<div className={styles.subBlock__left}>
											<span className={styles.subBlock__left__text}>
												Комментарий к отказу
											</span>
										</div>
										<div className={styles.subBlock__right}>
											<div className={styles.filterInput}>
												<textarea
													defaultValue={declineComment && declineComment}
													className={styles.textarea}
													onChange={handleTextareaChange}
													name='declineComment'
													id=''
													rows={10}
												/>
											</div>
										</div>
									</div>}

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Привязанный сотрудник
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												className={styles.filterSelect}
												name=''
												placeholder='Выбрать'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Желаемая должность
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												defaultValue={desiredPositionSelect}
												options={formData?.desiredPositions.map((el: any) => ({
													value: el,
													label: el,
												}))}
												propsChange={(event: any) =>
													selectChange(event, 'desiredPosition')
												}
												className={styles.filterSelect}
												placeholder={(desiredPosition && desiredPositionSelect) || 'Выбрать'}
												name='desiredPositions'
											/>
										</div>
									</div>
								</div>

								{desiredPositionSelect === "Другая" && <div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Новое название должности
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												defaultValue={!isDesiredPositionIncluded ? desiredPosition : ''}
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='newDesiredPosition'
												type='text'
											/>
										</div>
									</div>
								</div>}

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Фамилия<span className={styles.changed}>*</span></span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={clsx(styles.filterInput, errors.includes('lastName') && styles.error)}>
											<input
												defaultValue={lastName && lastName}
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='lastName'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Имя<span className={styles.changed}>*</span></span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={clsx(styles.filterInput, errors.includes('firstName') && styles.error)}>
											<input
												defaultValue={firstName && firstName}
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='firstName'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Отчество
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												defaultValue={middleName && middleName}
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='middleName'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Пол<span className={styles.changed}>*</span></span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={clsx(styles.filterInput, errors.includes('gender') && styles.error)}>
											<Select
												className={styles.filterSelect}
												defaultValue={
													gender ? gender : formData && formData.genders[0]
												}
												isShowPlaceholder={false}
												propsChange={(event: any) =>
													selectChange(event, 'gender')
												}
												options={formData?.genders.map((el: any) => ({
													value: Object.keys(el),
													label: Object.values(el),
												}))}
												placeholder={(gender && Object.values(gender)) || 'Выбрать'}
												name='gender'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Город</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='city'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Логин/Локация
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='login'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Метро/район проживания
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												defaultValue={subway && subway}
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='subway'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Комментарий
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<textarea
												onChange={handleTextareaChange}
												defaultValue={comment && comment}
												className={styles.textarea}
												name='comment'
												id=''
												rows={10}
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Телефон соискателя
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<InputMask
												mask='+7 (999) 999-99-99'
												onChange={handleInputChange}
												maskChar='_'
												name='phone'
												placeholder={phone ? phone : '+7 (___) ___-__-__'}
												value={phone}
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Источник рекламы
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={clsx(styles.filterInput, errors.includes('status') && styles.error)}>
											<Select
												className={styles.filterSelect}
												defaultValue={
													advertisingSources && advertisingSources
												}
												options={formData?.advertisingSources.map((el: any) => ({
													value: el.id,
													label: el.name,
												}))}
												propsChange={(event: any) =>
													selectChange(event, 'advertisingSource')
												}
												placeholder={
													(advertisingSource && advertisingSource.name) || 'Выбрать'
												}
												name='advertisingSource'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Категория рекламы
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={clsx(styles.filterInput, errors.includes('status') && styles.error)}>
											<Select
												className={styles.filterSelect}
												defaultValue={
													advertisingCategories && advertisingCategories
												}
												options={formData?.advertisingCategories.map((el: any) => ({
													value: el.id,
													label: el.name,
												}))}
												propsChange={(event: any) =>
													selectChange(event, 'advertisingCategory')
												}
												placeholder={
													(advertisingCategory && advertisingCategory.name) || 'Выбрать'
												}
												name='advertisingCategory'
											/>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TableSingleApplication;
